export default {"src":"/trader-new/_next/static/media/TranscationFooterActive.36127ed2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};